var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.updateAvailable)?_c('div',{staticClass:"confirm-update-service-worker-box",class:{'is-mobile': _vm.isMobile}},[_vm._v(" "+_vm._s(_vm.$t('alert.updateAvailable'))+" "),_c('div',{staticClass:"update-service-worker-btn",on:{"click":_vm.applyUpdate}},[_vm._v(_vm._s(_vm.$t('global.update')))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }